module.exports = __webpack_public_path__ + "img/nomination_form.f2c537a7.svg";